<template>
  <div class="well" style="padding: 1em; background: white;">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <!-- <div v-else-if="docRecord!=null && docRecord.type==0">
      <el-alert
        title="請先完成網路報名。"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> -->
    <div v-else>
      <div v-if="!mbFlag"> 
      <el-row :gutter="24">
        <el-col :span="15">
          <el-row>
              <el-button type="info" plain style="color: #131124; font-weight: bold;"
                  @click="showModal(0,'0')"><i class="el-icon-plus"></i> 新增推薦人</el-button>
          </el-row><br/>
          <el-table
              ighlight-current-row
              :data="docRecord.info"
              style="width: 100%;"
              border
              :row-class-name="tableRowClassName">
              <el-table-column
                  type="index"
                  label="序號"
                  width="50">
              </el-table-column>
              <el-table-column
                  prop="text1"
                  label="姓名"
                  width="90">
              </el-table-column>
              <el-table-column
                  prop="text2"
                  label="任職單位"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="text3"
                  label="職稱"
                  width="120">
              </el-table-column>
              <el-table-column
                prop="gId"
                label="狀態"
                width="150">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.gId === 2 ? 'danger' : (scope.row.gId === 3? 'success': 'warning')"
                    effect="dark">{{currentStatus(scope.row.gId)}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  width="150">
                  <template slot-scope="scope">
                      <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)"
                      v-if="scope.row.gId < 2">{{$t('message.Edit_cmd')}}</el-button>
                      <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)"
                      v-if="scope.row.gId < 2">{{$t('message.Del_cmd')}}</el-button>
                  </template>
              </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="9">
          <div class="div-memo" >
              <div class="text-header" style="top: -0.8em;">操作說明</div>
              <div v-html="memo">
              </div>
          </div>
        </el-col>
      </el-row>
      </div>
      <div v-if="mbFlag"> 
      <el-row :gutter="24">
        <el-col :span="24">
          <el-row>
              <el-button type="info" plain style="color: #131124; font-weight: bold;"
                  @click="showModal(0,'0')"><i class="el-icon-plus"></i> 新增推薦人</el-button>
          </el-row><br/>
          <el-table
              ighlight-current-row
              :data="docRecord.info"
              style="width: 100%;"
              border
              :row-class-name="tableRowClassName">
              <el-table-column
                  type="index"
                  label="序號"
                  width="50">
              </el-table-column>
              <el-table-column
                  prop="text1"
                  label="姓名"
                  width="90">
              </el-table-column>
              <el-table-column
                  prop="text2"
                  label="任職單位"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="text3"
                  label="職稱"
                  width="120">
              </el-table-column>
              <el-table-column
                prop="gId"
                label="狀態"
                width="150">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.gId === 2 ? 'danger' : (scope.row.gId === 3? 'success': 'warning')"
                    effect="dark">{{currentStatus(scope.row.gId)}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  width="150">
                  <template slot-scope="scope">
                      <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)"
                      v-if="scope.row.gId < 2">{{$t('message.Edit_cmd')}}</el-button>
                      <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)"
                      v-if="scope.row.gId < 2">{{$t('message.Del_cmd')}}</el-button>
                  </template>
              </el-table-column>
          </el-table>
        </el-col>        
      </el-row><br/>
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="div-memo" >
              <div class="text-header" style="top: -0.8em;">操作說明</div>
              <div v-html="memo">
              </div>
          </div>
        </el-col>
      </el-row>
      </div>
    </div>
    <modal name="hello-world"
      @closed="modalClose">
        hello, world!
    </modal>
  </div> 
</template>

<script id="modal-template">
import editData from '@/components/EditData.vue'
export default {
  name: 'recommend',
  components: {
    editData
  },
  data () {
    return {
        windowWidth: window.innerWidth,
        isModalVisible: false,
        docRecord:null,
        memo: ''
    }
  },
  computed: {
    mbFlag() {
      return (this.windowWidth < 992);
    },
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    },
    tableRowClassName({row, rowIndex}) {
          if (rowIndex %2 ==1) {
            return 'warning-row';
          } else {
            return 'success-row';
          }
    },
    // // 修改table header的背景色
    // tableHeaderColor({ row, column, rowIndex, columnIndex }) {
    //   if (rowIndex === 0) {
    //     return 'background-color: #ebf1fb;text-align:center'
    //   }else if(rowIndex === 1){
    //     return 'background-color: #f7faff;color: #1f2623;font-size:1.25rem;font-weight:bolder;text-align:center'
    //   }else if(rowIndex === 2){
    //     return 'background-color: #f7faff;color: #1f2623;font-size:1.25rem;font-weight:bolder;text-align:center'
    //   }
    // },
    showModal(id,hid) {
      this.$modal.show(editData, {
        recId: hid,
        mode: (0 == id? 1 : 2)
      }, {
        height: 'auto'
      }, {
        'closed': this.modalClose
      })
    },
    modalClose (event) {
    console.log('======modalClose====='+event);
        this.query();
    },
    handleEdit(index, row) {
        this.showModal(row.dId, row.hId);
    },
    handleDelete(index, row) {
      var vm = this
      this.$http.get('./WebApi/Apply/RemoveRecommendInfo/'.concat(row.hId))
        .then((response) => {
          if (response.data === true) {
            vm.$message({
              message: '恭喜您,刪除成功',
              type: 'success'
            })
            vm.query ()
          }
          else {
            vm.$message.error('對不起,刪除失敗')
          }
        })
        .catch(function (error) {
            vm.$message.error('對不起,網路連線失敗' + error)
        })
    },
    getRecommendMemo: function (id) {
      return this.$http
                 .get('./WebApi/Apply/GetRecommendMemo/'.concat(this.sysId));
    },
    getRecommendList: function () {
      return this.$http
                 .get('./WebApi/Apply/GetRecommendList/'.concat(this.user.hId));
    },
    query() {
        var vm = this;
        this.$http
            .get('./WebApi/Apply/GetRecommendList/'.concat(this.user.hId))
            .then(function(response) {
                if (response.data != null) {
                    vm.docRecord = response.data
                } else {
                    vm.docRecord = null;
                }
            })
            .catch(function (error) {
                vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
            })
    },
    currentStatus(status) {
      var ret = '';
      switch (status) {
        case 3:
          ret = '已完成推薦';
          break;
        case 2:
          ret = '已拒絶推薦';
          break;
        default:
          ret = '尚未上傳推薦檔案';
          break;
      }
      return ret;
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth =  window.innerWidth;
    }
  },
  mounted() {    
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  created () { 
    console.log('======created RecommendView=====');
    var vm = this;
    this.$http.all([vm.getRecommendMemo()])
              .then(vm.$http.spread(function (memoInfo) {
              //vm.dataContent = dataInfo.data;
                vm.memo = memoInfo.data; 
                vm.query();
              }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .td-style {
    width: 20%;
    text-align: right;
  }
  .div-memo {
    padding: 0.5em 0 0;
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-color: #fffef8;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
  .text-header {
    font-weight: bolder;
    text-align: center;
    top: 30px;
    width: 110px;
    position: absolute;
    background: white;
  }
  
  .el-table .warning-row {
    background: #f0f8ff;
    color: #1f2623;
    font-size:1rem;
    font-weight:bolder;
    text-align:center;
  }
  .el-table .success-row {
    background-color: #fffaf7;
    color: #1f2623;
    font-size:1rem;
    font-weight:bolder;
    text-align:center;
  }
  .el-table .header-row {
    background: #f0f9eb;
    color: #1f2623;
    font-weight:bolder;
    text-align:center;
  }
</style>


// WEBPACK FOOTER //
// src/components/RecommendView.vue